// components/Providers/SmtpTemplateManager.js
import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

const SmtpTemplateManager = ({ onTemplateSelect }) => {
  const [templates, setTemplates] = useState([]);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [editingTemplate, setEditingTemplate] = useState(null);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('prae.jwt');

  const [templateForm, setTemplateForm] = useState({
    name: '',
    host: '',
    port: 587,
    username: 'shark',
    password: '51c5159c7e1f2bfb2f0656fa03d4dba8',
    secure: false,
    server: 'shark05',
    outbound_ip: '',
    outbound_ip_local: '',
    outbound_helo: '',
    zone: '',
    daily_quota_max: 5000,
    description: '',
  });

  // Presets communs basés sur vos données
  const commonPresets = [
    {
      name: 'Shark05 nettoyage-des-locaux.fr',
      host: '173.234.136.205',
      outbound_ip: '173.234.136.205',
      outbound_ip_local: '173.234.136.205',
      outbound_helo: 'notification.nettoyage-des-locaux.fr',
      zone: 'nettoyage-des-locaux.fr',
    },
    {
      name: 'Shark05 nettoyage-33.fr',
      host: '23.19.59.102',
      outbound_ip: '23.19.59.102',
      outbound_ip_local: '23.19.59.102',
      outbound_helo: 'notification.nettoyage-33.fr',
      zone: 'nettoyage-33.fr',
    },
    {
      name: 'Shark05 nettoyage-75.fr',
      host: '173.234.136.204',
      outbound_ip: '173.234.136.204',
      outbound_ip_local: '173.234.136.204',
      outbound_helo: 'w.nettoyage-75.fr',
      zone: 'nettoyage-75.fr',
    },
    {
      name: 'Shark05 proprete-des-locaux.fr',
      host: '173.234.136.185',
      outbound_ip: '173.234.136.185',
      outbound_ip_local: '173.234.136.185',
      outbound_helo: 'm.proprete-des-locaux.fr',
      zone: 'proprete-des-locaux.fr',
    },
    {
      name: 'Shark05 menage-bureaux.fr',
      host: '173.234.138.7',
      outbound_ip: '173.234.138.7',
      outbound_ip_local: '173.234.138.7',
      outbound_helo: 'bienvenue.menage-bureaux.fr',
      zone: 'menage-bureaux.fr',
    },
    {
      name: 'Shark05 entretien-de-votre-jardin.fr',
      host: '173.234.138.6',
      outbound_ip: '173.234.138.6',
      outbound_ip_local: '173.234.138.6',
      outbound_helo: 'm.entretien-de-votre-jardin.fr',
      zone: 'entretien-de-votre-jardin.fr',
    },
    {
      name: 'Shark05 jardinier-a-proximite.fr ',
      host: '173.234.138.5',
      outbound_ip: '173.234.138.5',
      outbound_ip_local: '173.234.138.5',
      outbound_helo: 'votre.jardinier-a-proximite.fr',
      zone: 'jardinier-a-proximite.fr',
    },
    {
      name: 'Shark05 jardinier-autour-de-vous.fr',
      host: '173.234.138.4',
      outbound_ip: '173.234.138.4',
      outbound_ip_local: '173.234.138.4',
      outbound_helo: 'notification.jardinier-autour-de-vous.fr',
      zone: 'jardinier-autour-de-vous.fr',
    },
    {
      name: 'Shark06 nettoyage-courant.com',
      host: '81.17.56.218',
      outbound_ip: '81.17.56.218',
      outbound_ip_local: '81.17.56.218',
      outbound_helo: 'o.nettoyage-courant.com',
      zone: 'nettoyage-courant.com',
    },
    {
      name: 'Shark07 devislocalise.fr',
      host: '23.106.33.129',
      outbound_ip: '23.106.33.129',
      outbound_ip_local: '23.106.33.129',
      outbound_helo: 'client.devislocalise.fr',
      zone: 'devislocalise.fr',
    },
    {
      name: 'Shark03 artisans-ducoin.fr',
      host: '212.83.139.210',
      outbound_ip: '212.83.139.210',
      outbound_ip_local: '212.83.139.210',
      outbound_helo: 'hello.linkedclean.com',
      zone: 'artisans-ducoin.fr',
    },
    {
      name: 'Shark03 linkedclean.fr',
      host: '212.83.139.210',
      outbound_ip: '212.83.139.210',
      outbound_ip_local: '212.83.139.210',
      outbound_helo: 'hello.linkedclean.com',
      zone: 'linkedclean.fr',
    },
    {
      name: 'Shark03 votrejardinier.com',
      host: '212.83.140.155',
      outbound_ip: '212.83.140.155',
      outbound_ip_local: '212.83.140.155',
      outbound_helo: 'hello.actarius.fr',
      zone: 'votrejardinier.com',
    },
  ];

  const fetchTemplates = async () => {
    setLoading(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/smtp-templates`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = await res.json();
      setTemplates(data.templates || []);
    } catch (error) {
      console.error('Erreur chargement templates:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  const handleTemplateSubmit = async e => {
    e.preventDefault();
    setLoading(true);

    try {
      const url = editingTemplate
        ? `${process.env.REACT_APP_API_URL}/smtp-templates/${editingTemplate.id}`
        : `${process.env.REACT_APP_API_URL}/smtp-templates`;

      const method = editingTemplate ? 'PUT' : 'POST';

      const res = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(templateForm),
      });

      if (!res.ok) {
        const error = await res.json();
        throw new Error(error.error || 'Erreur sauvegarde template');
      }

      toast.success(editingTemplate ? 'Template mis à jour' : 'Template créé');
      setShowCreateForm(false);
      setEditingTemplate(null);
      setTemplateForm({
        name: '',
        host: '',
        port: 587,
        username: 'shark',
        password: '51c5159c7e1f2bfb2f0656fa03d4dba8',
        secure: false,
        server: 'shark05',
        outbound_ip: '',
        outbound_ip_local: '',
        outbound_helo: '',
        zone: '',
        daily_quota_max: 5000,
        description: '',
      });
      fetchTemplates();
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const applyPreset = preset => {
    setTemplateForm(prev => ({
      ...prev,
      ...preset,
    }));
  };

  const editTemplate = template => {
    setTemplateForm(template);
    setEditingTemplate(template);
    setShowCreateForm(true);
  };

  const deleteTemplate = async templateId => {
    // if (!confirm('Supprimer ce template ?')) return;

    try {
      await fetch(
        `${process.env.REACT_APP_API_URL}/smtp-templates/${templateId}`,
        {
          method: 'DELETE',
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success('Template supprimé');
      fetchTemplates();
    } catch (error) {
      toast.error('Erreur suppression');
    }
  };

  return (
    <div className="space-y-6">
      {/* Templates existants */}
      <div className="bg-white p-6 rounded-lg shadow">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Templates SMTP</h3>
          <button
            onClick={() => setShowCreateForm(true)}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            + Nouveau Template
          </button>
        </div>

        {loading ? (
          <div className="text-center py-4">Chargement...</div>
        ) : (
          <div className="grid gap-4">
            {templates.map(template => (
              <div
                key={template.id}
                className="border rounded p-4 flex justify-between items-center"
              >
                <div>
                  <h4 className="font-semibold">{template.name}</h4>
                  <p className="text-sm text-gray-600">
                    {template.host} - {template.zone} - {template.server}
                  </p>
                  {template.description && (
                    <p className="text-xs text-gray-500 mt-1">
                      {template.description}
                    </p>
                  )}
                </div>
                <div className="flex gap-2">
                  <button
                    onClick={() => onTemplateSelect?.(template)}
                    className="bg-green-600 text-white px-3 py-1 rounded text-sm hover:bg-green-700"
                  >
                    Utiliser
                  </button>
                  <button
                    onClick={() => editTemplate(template)}
                    className="bg-yellow-600 text-white px-3 py-1 rounded text-sm hover:bg-yellow-700"
                  >
                    Éditer
                  </button>
                  <button
                    onClick={() => deleteTemplate(template.id)}
                    className="bg-red-600 text-white px-3 py-1 rounded text-sm hover:bg-red-700"
                  >
                    Suppr.
                  </button>
                </div>
              </div>
            ))}
            {templates.length === 0 && (
              <div className="text-center py-4 text-gray-500">
                Aucun template configuré
              </div>
            )}
          </div>
        )}
      </div>

      {/* Formulaire création/édition template */}
      {showCreateForm && (
        <div className="bg-white p-6 rounded-lg shadow">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold">
              {editingTemplate ? 'Éditer Template' : 'Nouveau Template'}
            </h3>
            <button
              onClick={() => {
                setShowCreateForm(false);
                setEditingTemplate(null);
              }}
              className="text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
          </div>

          {/* Presets rapides */}
          <div className="mb-6">
            <h4 className="text-sm font-medium mb-2">Presets rapides :</h4>
            <div className="flex flex-wrap gap-2">
              {commonPresets.map(preset => (
                <button
                  key={preset.name}
                  onClick={() => applyPreset(preset)}
                  className="bg-gray-100 hover:bg-gray-200 px-3 py-1 rounded text-sm border"
                >
                  {preset.name}
                </button>
              ))}
            </div>
          </div>

          <form
            onSubmit={handleTemplateSubmit}
            className="grid grid-cols-1 md:grid-cols-2 gap-4"
          >
            <div>
              <label className="block text-sm font-medium mb-1">
                Nom du template *
              </label>
              <input
                required
                value={templateForm.name}
                onChange={e =>
                  setTemplateForm(prev => ({ ...prev, name: e.target.value }))
                }
                className="w-full border rounded px-3 py-2"
                placeholder="ex: Shark04 LinkedClean"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Host *</label>
              <input
                required
                value={templateForm.host}
                onChange={e =>
                  setTemplateForm(prev => ({ ...prev, host: e.target.value }))
                }
                className="w-full border rounded px-3 py-2"
                placeholder="84.234.25.56"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Port</label>
              <input
                type="number"
                value={templateForm.port}
                onChange={e =>
                  setTemplateForm(prev => ({
                    ...prev,
                    port: Number(e.target.value),
                  }))
                }
                className="w-full border rounded px-3 py-2"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">User</label>
              <input
                value={templateForm.username}
                onChange={e =>
                  setTemplateForm(prev => ({
                    ...prev,
                    username: e.target.value,
                  }))
                }
                className="w-full border rounded px-3 py-2"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Password</label>
              <input
                value={templateForm.password}
                onChange={e =>
                  setTemplateForm(prev => ({
                    ...prev,
                    password: e.target.value,
                  }))
                }
                className="w-full border rounded px-3 py-2"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Server</label>
              <select
                value={templateForm.server}
                onChange={e =>
                  setTemplateForm(prev => ({ ...prev, server: e.target.value }))
                }
                className="w-full border rounded px-3 py-2"
              >
                <option value="shark03">shark03</option>
                <option value="shark04">shark04</option>
                <option value="shark05">shark05</option>
                <option value="shark06">shark06</option>
                <option value="shark07">shark07</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                Outbound IP *
              </label>
              <input
                required
                value={templateForm.outbound_ip}
                onChange={e =>
                  setTemplateForm(prev => ({
                    ...prev,
                    outbound_ip: e.target.value,
                  }))
                }
                className="w-full border rounded px-3 py-2"
                placeholder="84.234.25.56"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                Outbound IP Local
              </label>
              <input
                value={templateForm.outbound_ip_local}
                onChange={e =>
                  setTemplateForm(prev => ({
                    ...prev,
                    outbound_ip_local: e.target.value,
                  }))
                }
                className="w-full border rounded px-3 py-2"
                placeholder="188.213.128.100"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                Outbound HELO *
              </label>
              <input
                required
                value={templateForm.outbound_helo}
                onChange={e =>
                  setTemplateForm(prev => ({
                    ...prev,
                    outbound_helo: e.target.value,
                  }))
                }
                className="w-full border rounded px-3 py-2"
                placeholder="bonjour.linkedclean.com"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Zone</label>
              <input
                value={templateForm.zone}
                onChange={e =>
                  setTemplateForm(prev => ({ ...prev, zone: e.target.value }))
                }
                className="w-full border rounded px-3 py-2"
                placeholder="linkedclean.com"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                Quota quotidien max
              </label>
              <input
                type="number"
                value={templateForm.daily_quota_max}
                onChange={e =>
                  setTemplateForm(prev => ({
                    ...prev,
                    daily_quota_max: Number(e.target.value),
                  }))
                }
                className="w-full border rounded px-3 py-2"
              />
            </div>

            <div className="md:col-span-2">
              <label className="block text-sm font-medium mb-1">
                Description
              </label>
              <textarea
                value={templateForm.description}
                onChange={e =>
                  setTemplateForm(prev => ({
                    ...prev,
                    description: e.target.value,
                  }))
                }
                className="w-full border rounded px-3 py-2"
                rows="2"
                placeholder="Description optionnelle du template..."
              />
            </div>

            <div className="md:col-span-2 flex gap-2 pt-4">
              <button
                type="submit"
                disabled={loading}
                className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 disabled:opacity-50"
              >
                {loading
                  ? 'Sauvegarde...'
                  : editingTemplate
                    ? 'Mettre à jour'
                    : 'Créer Template'}
              </button>
              <button
                type="button"
                onClick={() => {
                  setShowCreateForm(false);
                  setEditingTemplate(null);
                }}
                className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600"
              >
                Annuler
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default SmtpTemplateManager;
